import { StructuredBriefFragment } from '../BriefForm';

// Deprecated
export function isBifrostBrief(brief: StructuredBriefFragment) {
    return brief.request == null && brief.fulfilmentStrategy === 'FULFILMENT_STRATEGY_COMMUNITY';
}
